import './styles/NotFound.css';

const NotFound = () => {
    return (
        <div className="App">
            <header className="app-header">
                <h1 className='App-Title'>Sorry, this page doesn't exist</h1>
                <p>
                    But Jesus does, "Ask and it will be given to you; seek and you will find; knock and the door will be opened to you." Matthew 7:7
                </p>
            </header>
        </div>
    );
};

export default NotFound;